//PACKS
import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";

//STYLES
import "../styles/contactModal.scss";

export default function ContactModal(props) {
  //STATE
  const [toggle, setToggle] = useState(false);
  const [contactModalMessage, setContactModalMessage] = useState(null);

  //ON PROPS CHANGE
  useEffect(() => {
    if (props.contactModalMessage !== contactModalMessage) {
      setToggle(props.contactModalMessage.status);
    }
    setContactModalMessage(props.contactModalMessage);
  }, [props]);

  useEffect(() => {
    if (toggle) {
      setTimeout(() => {
        setToggle(false);
      }, 2000);
    }
  }, [toggle]);

  //ANIMATIONS
  const contactModalAnimation = useSpring({
    opacity: toggle ? 1 : 0,
    transform: toggle ? "translatey(0)" : "translatey(-200px)",
  });

  return props.contactModalMessage.status ? (
    <animated.div
      style={contactModalAnimation}
      className="contactModalContainer"
      // onClick={() => {
      //   setToggle(false);
      // }}
    >
      <p>{props.contactModalMessage.response}</p>
      {/* <p>OK</p> */}
    </animated.div>
  ) : (
    <></>
  );
}
